import { Component } from "@angular/core";

@Component({
    selector: "app-terms-and-conditions-content",
    templateUrl: "./terms-and-conditions-content.component.html",
    styleUrls: ["../legal-documents.scss"],
    standalone: false,
})
export class TermsAndConditionsContentComponent {
    constructor() {}
}
